import { Preference } from './preference.model';

export class TablePreference {

    public tableId: string;

    public favouriteConfig: Preference;
    public columnConfig: Preference;
    public columGroupConfig: Preference;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/search/models/table-preference.model.ts